import { toast } from 'react-toastify';

/**
 * Maneja errores de API de forma centralizada
 * @param {Error} error - Error de axios
 * @param {string} defaultMessage - Mensaje por defecto si no hay mensaje específico
 * @returns {string} - Mensaje de error procesado
 */
export const handleApiError = (error, defaultMessage = 'Error en la operación') => {
  let errorMessage = defaultMessage;

  if (error.response) {
    // Error de respuesta del servidor
    const { status, data } = error.response;
    
    switch (status) {
      case 400:
        // FastAPI puede retornar 'detail' o 'message'
        errorMessage = data?.detail || data?.message || 'Datos inválidos';
        break;
      case 401:
        errorMessage = data?.detail || data?.message || 'No autorizado. Verifique sus credenciales';
        break;
      case 403:
        errorMessage = data?.detail || data?.message || 'No tiene permisos para realizar esta acción';
        break;
      case 404:
        errorMessage = data?.detail || data?.message || 'Recurso no encontrado';
        break;
      case 422:
        // FastAPI retorna 'detail' en lugar de 'message' para errores de validación
        errorMessage = data?.detail || data?.message || 'Error de validación';
        break;
      case 500:
        errorMessage = 'Error interno del servidor';
        break;
      default:
        // FastAPI puede retornar 'detail' o 'message'
        errorMessage = data?.detail || data?.message || defaultMessage;
    }
  } else if (error.request) {
    // Error de red
    errorMessage = 'Error de conexión. Verifique su conexión a internet';
  } else {
    // Error de configuración
    errorMessage = error.message || defaultMessage;
  }

  console.error('API Error:', error);
  return errorMessage;
};

/**
 * Muestra un toast de error y retorna el mensaje
 * @param {Error} error - Error de axios
 * @param {string} defaultMessage - Mensaje por defecto
 * @returns {string} - Mensaje de error
 */
export const showErrorToast = (error, defaultMessage) => {
  const message = handleApiError(error, defaultMessage);
  toast.error(message, {
    position: "bottom-right",
    autoClose: 3000
  });
  return message;
};

/**
 * Muestra un toast de éxito
 * @param {string} message - Mensaje de éxito
 */
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "bottom-right",
    autoClose: 2000
  });
};

/**
 * Muestra un toast de advertencia
 * @param {string} message - Mensaje de advertencia
 */
export const showWarningToast = (message) => {
  toast.warning(message, {
    position: "bottom-right",
    autoClose: 3000
  });
};
